import { ResetPasswordRequestVO } from "./resetpassword.model";
import { UserVO } from "../sso/sso.models";

export abstract class ProfileService {

    abstract resetPassword(resetPasswordRequestVO: ResetPasswordRequestVO): Promise<void>;
    abstract editUser(userVO: UserVO): Promise<UserVO>;
    abstract getUserDetails(): Promise<UserVO>;
}


// WEBPACK FOOTER //
// ./src/app/profile/profile.service.ts